/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/edit': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M9.946 3.108H2.988A1.988 1.988 0 001 5.096v13.916A1.988 1.988 0 002.988 21h13.915a1.988 1.988 0 001.988-1.988v-6.958" _stroke="#151716" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M17.401 1.618a2.109 2.109 0 012.982 2.981l-9.442 9.443-3.976.994.994-3.976L17.4 1.618z" _stroke="#151716" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
